import { Button, Container, DialogActions, DialogContent, DialogTitle, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MagicLinkStore } from '@app/api/MagicLinkStore';

/**
 * Where magic links land. Signing in waits for the Sign In button because email security scanners
 * (e.g. Microsoft Safe Links) and link previews open links before the person does; if opening the link
 * signed in, the scanner would use it up and the person would be told it was already used.
 *
 * The button calls the API from the app instead of navigating to it, because privacy-focused browsers
 * (e.g. Brave in Gmail's in-app tab) drop cookies set during a redirect (WHE-986).
 */
export const MagicLinkConfirm: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [isSigningIn, setIsSigningIn] = useState(false);

  const signIn = async () => {
    setIsSigningIn(true);
    try {
      const { redirectTo } = await new MagicLinkStore().verifyMagicLink(token);
      window.location.assign(redirectTo);
    } catch {
      window.location.assign('/auth-error?error=auth_failed');
    }
  };

  return (
    <Container sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', height: '100vh' }}>
      <Paper sx={{ width: '100%', maxWidth: '500px' }}>
        <DialogTitle>Sign in to We Hate Exercise</DialogTitle>
        <DialogContent>
          <Typography>
            {token
              ? 'Tap the button below to finish signing in.'
              : 'This sign-in link is incomplete. Please request a new one.'}
          </Typography>
        </DialogContent>
        <DialogActions>
          {token ? (
            <Button
              variant={'contained'}
              onClick={signIn}
              disabled={isSigningIn}
              sx={{ margin: '0 auto 25px', width: '80%' }}
            >
              {isSigningIn ? 'Signing in…' : 'Sign In'}
            </Button>
          ) : (
            <Button variant={'contained'} href="/" sx={{ margin: '0 auto 25px', width: '80%' }}>
              Back to Sign In
            </Button>
          )}
        </DialogActions>
      </Paper>
    </Container>
  );
};
